<template>
  <div style="float:right">
    <span v-if="$vuetify.breakpoint.smAndUp" class="caption">Download as </span>
    <v-btn small class="caption" @click="download('PDF')" style="min-width:0">PDF</v-btn>
    <v-btn small class="caption" @click="download('CSV')" style="min-width:0">CSV</v-btn>
  </div>
</template>

<script>
import config from '@/config/app-cfg'
import handy from '@/utils/handy'
var JsPDF = require('jspdf')
require('jspdf-autotable')

export default {
  props: ['headers', 'items', 'title', 'subtitle', 'tablefooter', 'letterHead', 'landscape', 'fontsize', 'cellpadding', 'legend'],
  methods: {
    download (type) {
      /* NOTE:
      Making use of PDF plug-in to generate CSV file as well
      */
      // construnct cols from passed table heading
      var cols = []
      var colStyle = {}
      var colFormat = []
      this.headers.forEach(rec => {
        if (rec.text) {
          // column title and value key
          cols.push({title: rec.text, dataKey: rec.value})
          // column style if any
          if (rec.align || rec.columnWidth) {
            colStyle[rec.value] = {}
            if (rec.align) {
              colStyle[rec.value].halign = rec.align
            }
            if (rec.columnWidth) {
              colStyle[rec.value].columnWidth = rec.columnWidth
            }
          }
          // column format if any
          colFormat[rec.value] = rec.format
        }
      })
      // local copy for later use
      var locItems = this.items

      // pdf
      var doc = null
      if (this.landscape) {
        doc = new JsPDF('landscape')
      } else {
        doc = new JsPDF()
      }

      var totalPagesExp = '{total_pages_count_string}'
      var pageContent = (data) => {
        // HEADER
        doc.setFontSize(20)
        doc.setFontStyle('normal')
        // a. community details
        if (!this.letterHead) {
          doc.setTextColor(139, 195, 74)
          doc.text(config.COMM_NAME, data.settings.margin.left, 15)
          doc.setDrawColor(241, 241, 241)
          doc.line(0, 20, doc.internal.pageSize.width || doc.internal.pageSize.getWidth(), 20)
        }
        doc.setTextColor(40)

        // b. report heading
        doc.setFontSize(16)
        doc.text(this.title, data.settings.margin.left, 30)
        // c. report subheading
        if (this.subtitle) {
          doc.setFontSize(10)
          doc.text(this.subtitle, data.settings.margin.left, 35)
        }

        // FOOTER
        var str = 'Page ' + data.pageCount
        // Total page number plugin only available in jspdf v1.0+
        if (typeof doc.putTotalPages === 'function') {
          str = str + ' of ' + totalPagesExp
        }
        doc.setFontSize(10)
        var pageHeight = doc.internal.pageSize.height || doc.internal.pageSize.getHeight()
        doc.text(str + '\nDownloaded By ' + config.CUST_NAME + ' On ' + handy.formatDate(new Date()) + ' ' + handy.getTime12Hrs(new Date()), data.settings.margin.left, pageHeight - 10)
      }

      // FULL CONTENT
      var csvHeader = ''
      var csvCont = []
      var csvLine = []
      doc.autoTable(cols, this.items, {
        theme: 'grid',
        addPageContent: pageContent,
        margin: {top: this.subtitle ? 40 : 35},
        columnStyles: colStyle,
        styles: {
          fontSize: this.fontsize || 10,
          cellPadding: this.cellpadding || 2,
          overflow: 'linebreak'
        },
        createdCell: function (cell, data) {
          if (cell.raw === null) {
            // special handling for nulls
            cell.text[0] = ''
            cell.raw = ''
          } else if (colFormat[data.column.dataKey]) { // formatting
            // format as requested
            cell.text[0] = handy[colFormat[data.column.dataKey]](cell.raw)
          } else if (data.column.dataKey.indexOf('_list') < 0 && (data.column.dataKey.indexOf('_dt') >= 0 || data.column.dataKey.indexOf('_date') >= 0 || data.column.dataKey.indexOf('_on') >= 0)) {
            // special handling for dates
            cell.text[0] = handy.formatDate(cell.raw)
          } else if (data.column.dataKey.indexOf('_time') >= 0 || data.column.dataKey.indexOf('_in') >= 0 || data.column.dataKey.indexOf('_out') >= 0) {
            // special handling for date time
            cell.text[0] = handy.formatDisplayDateTime(cell.raw)
          } else if (data.column.raw.title.indexOf('?') >= 0) {
            // special handling boolean
            if (cell.raw === 0 || cell.raw === 1 || typeof cell.raw === 'boolean') {
              cell.text[0] = (!cell.raw ? 'No' : 'Yes')
            }
          }
        },
        drawRow: function (row, data) { // used for CSV & to highlight footer
          csvLine = []
          for (var col in row.cells) {
            if (row.cells[col].text.length) {
              csvLine.push('"' + (row.cells[col].raw && row.cells[col].raw.length > 1 ? row.cells[col].raw : row.cells[col].text) + '"')
            }
            if (locItems[row.index].styles) { // highlight / style row if required
              for (var atr in locItems[row.index].styles) {
                row.cells[col].styles[atr] = locItems[row.index].styles[atr]
              }
            }
          }
          if (!csvCont[row.index] && csvLine.length) {
            csvCont[row.index] = csvLine.join()
          }
        }
      })

      // table legend
      if (this.legend) {
        doc.setFontSize(8)
        doc.text(this.legend, 15, doc.autoTable.previous.finalY + 4)
      }

      // table footer
      if (this.tablefooter) {
        doc.setFontSize(12)
        doc.text(this.tablefooter, 15, doc.autoTable.previous.finalY + 10)
      }

      // page footer
      if (typeof doc.putTotalPages === 'function') {
        doc.putTotalPages(totalPagesExp)
      }

      // download
      if (type === 'PDF') {
        doc.save(this.title + '.pdf')
      } else { // csv
        csvHeader = cols.map(rec => rec.title).join() + '\n'
        csvCont = csvHeader + csvCont.filter(rec => rec).join('\n')
        // table footer if requested
        if (this.tablefooter) {
          csvCont += '\n' + this.tablefooter
        }

        var blob = new Blob([csvCont])
        var link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob, {type: 'text/plain'})
        link.setAttribute('download', this.title + (this.subtitle ? ' ' + this.subtitle : '') + '.csv')
        document.body.appendChild(link) // Required for FF
        link.click()
        document.body.removeChild(link)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// VDownloadAs.vue?25ba2a2a